import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getEmailTemplates = payload => api.get('/platform/email-temps', payload)

const getEmailTemplateHtml = payload =>
  api.get(`/platform/email-temps/${payload.emailTempId}/html-replace-url`, payload)

const getEmailTemplateHisHtml = payload =>
  api.get(`/platform/email-temps/his/${payload.emailTempId}/html-replace-url`, payload)

const getEmailTemplateLabels = payload => api.get('/platform/email-temps/labels', payload)

const getEmailTemplateAddableLabels = payload =>
  api.get(`/platform/email-temps/${payload.emailTempId}/label-addable`, {
    params: payload.params,
  })

const getEmailTemplateLabelsById = payload =>
  api.get(`/platform/email-temps/${payload.emailTempId}/labels`, { params: payload.params })

const getEmailTemplateById = payload =>
  api.get(`/platform/email-temps/${payload.emailTempId}`, { params: payload.params })

const getEmailTemplateHisById = payload =>
  api.get(`/platform/email-temps/his/${payload.emailTempId}`, { params: payload.params })

const createEmailTemplate = payload =>
  api.post(`/platform/email-temps`, payload.data, { params: payload.params })

const editEmailTemplate = payload =>
  api.put(`/platform/email-temps`, payload.data, { params: payload.params })

const deleteEmailTemplate = payload =>
  api.delete(`/platform/email-temps/${payload.emailTempId}`, { params: payload.params })

const deleteEmailTemplateLabel = payload =>
  api.delete(`/platform/email-temps/labels/${payload.labelId}`, { params: payload.params })

const uploadEmailTemplateImage = payload =>
  api.post('/platform/email-temps/images', payload.data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
    params: payload.params,
  })

export default {
  getEmailTemplates,
  getEmailTemplateHtml,
  getEmailTemplateHisHtml,
  getEmailTemplateLabels,
  getEmailTemplateAddableLabels,
  getEmailTemplateLabelsById,
  getEmailTemplateById,
  getEmailTemplateHisById,
  createEmailTemplate,
  editEmailTemplate,
  deleteEmailTemplate,
  deleteEmailTemplateLabel,
  uploadEmailTemplateImage,
}
